'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _link = require('./components/link');

var _link2 = _interopRequireDefault(_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _link2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@storybook/addon-links/dist/react/index.js
// module id = 1013
// module chunks = 0